var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "search-2-line 2",
    clipPath: "url(#clip0_5104_1281)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.16748 1.66602C13.3075 1.66602 16.6675 5.02602 16.6675 9.16602C16.6675 13.306 13.3075 16.666 9.16748 16.666C5.02748 16.666 1.66748 13.306 1.66748 9.16602C1.66748 5.02602 5.02748 1.66602 9.16748 1.66602ZM9.16748 14.9993C12.39 14.9993 15.0008 12.3885 15.0008 9.16602C15.0008 5.94268 12.39 3.33268 9.16748 3.33268C5.94415 3.33268 3.33415 5.94268 3.33415 9.16602C3.33415 12.3885 5.94415 14.9993 9.16748 14.9993ZM16.2383 15.0585L18.5958 17.4152L17.4166 18.5943L15.06 16.2368L16.2383 15.0585Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5104_1281"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.000976562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchB);
export default __webpack_public_path__ + "static/media/search-b.5ea3e130f1b230c9ddea44552a22c42d.svg";
export { ForwardRef as ReactComponent };